import { Component, HostBinding, Input } from '@angular/core';
import { TaskStatus, ThemePalette } from 'shared/enums';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
})
export class BadgeComponent {
  // TODO: remove TaskStatus here
  @Input() public color: ThemePalette | TaskStatus | string = 'neutral';
  @Input() public number = 0;
  @Input() public label = 'Badge';

  @HostBinding('class')
  private get hostClasses(): string {
    const classes = ['badge'];
    classes.push(`badge-${this.color.toLowerCase()}`, `badge-width-${this.number.toString().length}`);
    return classes.join(' ');
  }
}
